module.exports = __webpack_public_path__ + "img/mi-view-in-ar.73911612.svg";